import moment from "moment/moment";

export function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatDate(inputDate) {
  const m = moment(inputDate).utc().utcOffset(240); // GMT+4
  const formattedDate = m.format("DD MMM YYYY HH:mm:ss");
  return capitalizeFirstLetter(`${formattedDate} GMT+4`);
}

export function formatDateMonthInFront(inputDate, lang = "en") {
  const m = moment(inputDate).utc().utcOffset(240); // GMT+4;
  const formattedDate = m.format(
    lang === "en" ? "MMMM DD, YYYY • HH:mm:ss" : "DD MMMM YYYY • HH:mm:ss",
  );
  return capitalizeFirstLetter(`${formattedDate} GMT+4`);
}

export function formatDateUTC(inputDate) {
  const m = moment(inputDate).utc();
  const formattedDate = m.format("DD MMM YYYY HH:mm:ss");
  return capitalizeFirstLetter(`${formattedDate} UTC`);
}
